import { AvField, AvForm } from "availity-reactstrap-validation";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, Card, CardBody, Col, Container, Label, Row } from "reactstrap";
import Breadcrumbs from '../../components/Common/Breadcrumb';
import { useFormik } from "formik";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { DATABASE_CLIENT_PAGE } from "../../routes/routeConstants";
import { clientActions } from "./clientSlice";

const initForm = { raison: '', type: ''};
const ClientForm = () => {
    const { t } = useTranslation('translation');
    const [formState, setForm] = useState(initForm);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    let { id } = useParams();

    useEffect(() => {
        if (id) {
            let payload = {
                id,
                onSuccess: (data) => {
                    setForm({ ...data });
                }
            }
            dispatch(clientActions.find(payload));
        }
    }, [id, dispatch]);

    const breadcrumbItems = [
        { title: t('database'), link: "#" },
        { title: t('client'), link: DATABASE_CLIENT_PAGE },
        { title: id > 0 ? t('editclient') : t('newclient'), link: "#" }
    ];

    const formik = useFormik({
        initialValues: { ...formState },
        enableReinitialize: true,
        onSubmit: (values) => {
            let payload = {
                data: values,
                onSuccess: () => {
                    navigate(DATABASE_CLIENT_PAGE)
                }
            }
            dispatch(clientActions.create(payload))
        }
    });


    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid={true}>
                    <Breadcrumbs title={t('newclient')} breadcrumbItems={breadcrumbItems} />
                    <Card>
                        <CardBody>
                            <AvForm className="needs-validation" onValidSubmit={formik.handleSubmit} >
                                <Row>
                                    <Col md="4">
                                        <div className="mb-3">
                                            <Label className="form-label">{t('clientf.type')}</Label>
                                            <Col md={10}>
                                                <select className="form-control" {...formik.getFieldProps('type')} required>
                                                    <option>Sélectionner...</option>
                                                    <option value="ENTREP">Entreprise</option>
                                                    <option value="PARTIC">Particulier</option>
                                                </select>
                                            </Col>
                                        </div>
                                    </Col>
                                    <Col md="3">
                                        <div className="mb-3">
                                            <Label className="form-label" htmlFor="raison">{t('clientf.raison')}</Label>
                                            <AvField
                                                {...formik.getFieldProps('raison')}
                                                placeholder={t('clientf.raison')}
                                                type="text"
                                                errorMessage={t('message.required')}
                                                className="form-control"
                                                validate={{ required: { value: true } }}
                                                id="raison"
                                            />
                                        </div>
                                    </Col>
                                </Row>

                                <Button color="primary" type="submit">{t('actions.save')}</Button>
                            </AvForm>
                        </CardBody>
                    </Card>
                </Container>
            </div>
        </React.Fragment>
    )
}

export default ClientForm;
